import styled from "styled-components";
import { maxSize, px2vw } from "../../Utils/common";
import { STYLE_TYPE } from "../../Utils/magicStrings";

export const BottomWrapper = styled('div')`
    ${props => maxSize(112, props.styleType, 'margin-top', 48)};
    width: 100vw;
    ${props => maxSize(184, props.styleType, 'height', 101)};
    background: black;
    position: relative;
`;

export const TextWrapper = styled('div')`
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    color: #DFDFDF;
    ${props => maxSize(190, props.styleType, 'left', 131)};
    ${props => maxSize(14, props.styleType, 'font-size', 10)};
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `width: ${px2vw(240, 375)}; top: ${px2vw(35, 375)}; transform: initial`
        }
    }};
    & :last-child {
        margin-right: 0;
    }
    & div {
        display: inline-block;
        ${props => maxSize(32, props.styleType, 'margin-right', 24)};
    }
`;

export const ExplanTextWrapper = styled('div')`
    position: absolute;
    top: 65%;
    transform: translate(0, -50%);
    color: #DFDFDF;
    ${props => maxSize(190, props.styleType, 'left', 131)};
    ${props => maxSize(14, props.styleType, 'font-size', 10)};
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `width: ${px2vw(135, 375)}; top: ${px2vw(55, 375)}; transform: initial`
        }
    }};
`;

export const Rights = styled('div')`
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    color: white;
    ${props => maxSize(90, props.styleType, 'right', 32)};
    ${props => maxSize(14, props.styleType, 'font-size', 8)};
    ${props => props.styleType === STYLE_TYPE.MOBILE ? `top: ${px2vw(61, 375)}; transform: initial;` : ''}
`;

export const BottomLogo = styled('div')`
    ${props => maxSize(72, props.styleType, 'left', 32)};
    ${props => maxSize(58, props.styleType, 'width', 36)};
    ${props => maxSize(65, props.styleType, 'height', 43)};
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    & img {
        width: 100%;
        height: 100%;
    }
`;
